import './general.scss';
import './icons.scss';

import './components/form.scss';
import './components/slider.scss';